module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-flex-centered g-bg-img-hero g-bg-pos-top-center g-bg-cover g-bg-bluegray-opacity-0_2--after",
    staticStyle: {
      "background-image": "url('../../../../static/assets/img/bg/Portal Photo_KidImage4.jpeg')",
      "background-position": "center"
    },
    attrs: {
      "data-calc-target": "#js-header"
    }
  }, [_c('div', {
    staticClass: "container g-pos-rel g-z-index-1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center g-py-20"
  }, [_c('a', {
    staticClass: "g-color-main g-color-primary--hover",
    on: {
      "click": function($event) {
        return _vm.ArrowDown()
      }
    }
  }, [_vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-shadow-v36 g-max-width-500 g-bg-main-light-v1 g-pa-50 g-mt-130 g-mb-100"
  }, [_c('div', {
    staticClass: "g-mb-10"
  }, [_c('h1', {
    staticClass: "g-color-white g-font-size-40--md mb-3"
  }, [_vm._v("Resources")]), _vm._v(" "), _c('p', {
    staticClass: "g-color-white-opacity-0_8 g-font-size-20"
  }, [_vm._v("Want to get involved, but aren’t sure where to start?  Check out these helpful guides and useful educational tools to explore ways to get engaged in your community.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-chevron-down",
    staticStyle: {
      "font-size": "30px"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2afd6508", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2afd6508"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/resourceData/ResourcePromo.vue
// module id = 480
// module chunks = 3